import {
  ShortcutTooltipV2,
  ViewportAwareShortcutTooltipV2,
  ViewportAwareShortcutTooltipV2Props,
  type ShortcutTooltipV2Props,
} from "@/components/interactive/ShortcutTooltipV2";
import { useActionKey } from "@/utils/hooks/use-action-key";
import React, { useMemo } from "react";

export type SidebarToggleShortcutHint = "action" | "bracket";

const useSidebarToggleShortcutKeys = (shortcut: SidebarToggleShortcutHint) => {
  const [actionKey, actionKeyLabel] = useActionKey();

  return useMemo(
    () =>
      shortcut === "bracket"
        ? [{ value: "[" }]
        : [{ value: actionKey.trim(), ariaLabel: actionKeyLabel }, { value: "B" }],
    [actionKey, actionKeyLabel, shortcut],
  );
};

export const SidebarToggleShortcutTooltip: React.FC<
  Omit<ShortcutTooltipV2Props, "keys"> & { shortcut?: SidebarToggleShortcutHint }
> = ({ shortcut = "bracket", ...props }) => {
  const keys = useSidebarToggleShortcutKeys(shortcut);

  return <ShortcutTooltipV2 {...props} keys={keys} />;
};

export const ViewportAwareSidebarToggleShortcutTooltip: React.FC<
  Omit<ViewportAwareShortcutTooltipV2Props, "keys"> & { shortcut?: SidebarToggleShortcutHint }
> = ({ shortcut = "bracket", ...props }) => {
  const keys = useSidebarToggleShortcutKeys(shortcut);

  return <ViewportAwareShortcutTooltipV2 {...props} keys={keys} />;
};
